class GameRating {

    constructor() {
        this.starsContainer = null;
        this.fullStarsContainer = null;
        this.stars = null;
        this.hovering = false;
        this.config = null;
    }

    init(config) {
        let that = this;
        this.config = config;
        that.starsContainer = $('#game-rating_' + config.id + ' .stars');
        that.stars = that.starsContainer.find('.star');
        that.stars.hover(function () {
            that.hovering = true;
            that.colorStars(jQuery(this).data('score'))
        }, function () {
            that.hoverOut();
        });
        that.stars.on('click', function () {
            that.castVote(jQuery(this).data('score'));
        });
        that.reset();
    }

    colorStars(score) {
        for (let i in this.stars) {
            if (typeof this.stars[i] === "object") {
                let star = $(this.stars[i]);
                if (parseInt(star.data("score")) <= score) {
                    star.addClass("star-filled");
                } else {
                    star.removeClass("star-filled");
                }
            }
        }
    }

    setFavorite(id) {
        app.ajax.post("/services/game/favorite", {id: id}, (data) => {
            if (data.status) {
                let heart = $("#favorite-game i");
                let count = $("#favorite-game .count");
                let countValue = parseInt(count.html());
                if (heart.hasClass("active")) {
                    count.html(countValue - 1);
                    heart.removeClass("active");
                } else {
                    count.html(countValue + 1);
                    heart.addClass("active");
                }
            } else {
                app.alert.error(data.header, data.message);
            }
        });

    }

    reset() {
        this.colorStars(this.config.ownRating);
    }

    hoverOut() {
        this.hovering = false;
        setTimeout(function () {
            if (!this.hovering) {
                this.reset();
            }
        }.bind(this), 100);
    }


    castVote(score) {
        if (this.config.ownRating !== score) {
            app.ajax.post('/services/game/rating/insert', {
                rating: score,
                id: this.config.id
            }, function () {
                this.config.ownRating = score;
                if (!this.hovering) {
                    this.reset();
                }
            }.bind(this));
        }
    }
}